export const preventPageScroll = (on: boolean) => {
  const content: HTMLIonContentElement | null = document.querySelector(':not(.ion-page-hidden) > ion-content')
  if (on) {
    content?.classList.add('no-scroll')
  } else {
    content?.classList.remove('no-scroll')
  }
}
